export const Filter = {
  Date: "date" as const,
  State: "state" as const,
  Type: "type" as const,
  Source: "source" as const,
  Amount: "amount" as const,
  From: "from" as const,
  Subject: "subject" as const,
}

